import { FC } from 'react';
import { Pause, Play } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Slider } from '@/components/ui/slider';

interface TimelineScrubberProps {
  min: number;
  max: number;
  value: number;
  playing: boolean;
  onChange: (value: number) => void;
  onTogglePlay: () => void;
}

const formatTime = (ms: number): string =>
  new Date(ms).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

export const TimelineScrubber: FC<TimelineScrubberProps> = ({
  min,
  max,
  value,
  playing,
  onChange,
  onTogglePlay,
}) => (
  <div className='bg-background/85 flex items-center gap-3 rounded-md border px-3 py-1.5 backdrop-blur-sm'>
    <Button
      variant='ghost'
      size='icon'
      className='h-7 w-7 shrink-0'
      onClick={onTogglePlay}
      aria-label={playing ? 'Pause timeline' : 'Play timeline'}
    >
      {playing ? <Pause className='size-4' /> : <Play className='size-4' />}
    </Button>
    <Slider
      value={[value]}
      min={min}
      max={max}
      step={Math.max((max - min) / 500, 1)}
      onValueChange={([next]) => onChange(next)}
      className='w-56'
      aria-label='Timeline position'
    />
    <span className='text-muted-foreground w-24 shrink-0 text-right text-xs tabular-nums'>
      {formatTime(value)}
    </span>
  </div>
);
